module.exports = __webpack_public_path__ + "static/media/modern-editor-2A.b90e0f99.png";